var map = {
	"./10corazon.png": [
		"9a0c",
		"chunk-2d0efc71"
	],
	"./10diamante.png": [
		"93dc",
		"chunk-2d0e560f"
	],
	"./10pica.png": [
		"2cc4",
		"chunk-2d0bdb58"
	],
	"./10trebol.png": [
		"0368",
		"chunk-2d0a38fb"
	],
	"./2corazon.png": [
		"4954",
		"chunk-2d0c20da"
	],
	"./2diamante.png": [
		"39b1",
		"chunk-2d0bb1eb"
	],
	"./2pica.png": [
		"d87a",
		"chunk-2d21ef54"
	],
	"./2trebol.png": [
		"3786",
		"chunk-2d0ba558"
	],
	"./3corazon.png": [
		"e19f",
		"chunk-2d2249af"
	],
	"./3diamante.png": [
		"533e",
		"chunk-2d0c7ea6"
	],
	"./3pica.png": [
		"637b",
		"chunk-2d0cf37e"
	],
	"./3trebol.png": [
		"2c77",
		"chunk-2d0bd607"
	],
	"./4corazon.png": [
		"d819",
		"chunk-2d21ee72"
	],
	"./4diamante.png": [
		"1f17",
		"chunk-2d0b6c31"
	],
	"./4pica.png": [
		"0608",
		"chunk-2d0a4384"
	],
	"./4trebol.png": [
		"9d50",
		"chunk-2d0f081c"
	],
	"./5corazon.png": [
		"a946",
		"chunk-2d209570"
	],
	"./5diamante.png": [
		"c888",
		"chunk-2d217aeb"
	],
	"./5pica.png": [
		"5b49",
		"chunk-2d0d2f08"
	],
	"./5trebol.png": [
		"b16d",
		"chunk-2d20ec33"
	],
	"./6corazon.png": [
		"7317",
		"chunk-2d0d66f8"
	],
	"./6diamante.png": [
		"8f8e",
		"chunk-2d0e9bd1"
	],
	"./6pica.png": [
		"0f7b",
		"chunk-2d0af8b7"
	],
	"./6trebol.png": [
		"54b1",
		"chunk-2d0c87e4"
	],
	"./7corazon.png": [
		"044d",
		"chunk-2d0a3caa"
	],
	"./7diamante.png": [
		"0f61",
		"chunk-2d0af867"
	],
	"./7pica.png": [
		"d7e8",
		"chunk-2d21f0fc"
	],
	"./7trebol.png": [
		"9072",
		"chunk-2d0e4528"
	],
	"./8corazon.png": [
		"345b",
		"chunk-2d0b99e4"
	],
	"./8diamante.png": [
		"9849",
		"chunk-2d0e62da"
	],
	"./8pica.png": [
		"5907",
		"chunk-2d0c94a1"
	],
	"./8trebol.png": [
		"0c0f",
		"chunk-2d0aec9f"
	],
	"./9corazon.png": [
		"940a",
		"chunk-2d0e5382"
	],
	"./9diamante.png": [
		"6253",
		"chunk-2d0cef50"
	],
	"./9pica.png": [
		"fd0a",
		"chunk-2d237c65"
	],
	"./9trebol.png": [
		"68cd",
		"chunk-2d0d0b99"
	],
	"./Acorazon.png": [
		"2021",
		"chunk-2d0b15f3"
	],
	"./Adiamante.png": [
		"28b5",
		"chunk-2d0b39cf"
	],
	"./Apica.png": [
		"0cf3",
		"chunk-2d0af2f6"
	],
	"./Atrebol.png": [
		"8a6e",
		"chunk-2d0e88ce"
	],
	"./Jcorazon.png": [
		"19be",
		"chunk-2d0ac961"
	],
	"./Jdiamante.png": [
		"4a47",
		"chunk-2d0cb6e6"
	],
	"./Jpica.png": [
		"0ffb",
		"chunk-2d0afe68"
	],
	"./Jtrebol.png": [
		"9820",
		"chunk-2d0e6293"
	],
	"./KGoldcorazon.png": [
		"bc45",
		"chunk-2d21a778"
	],
	"./KGolddiamante.png": [
		"236f",
		"chunk-2d0b21e7"
	],
	"./KGoldpica.png": [
		"36e1",
		"chunk-2d0ba705"
	],
	"./KGoldtrebol.png": [
		"6cca",
		"chunk-2d0dad01"
	],
	"./Kcorazon.png": [
		"8f10",
		"chunk-2d0e9ac3"
	],
	"./Kdiamante.png": [
		"ef26",
		"chunk-2d230f9b"
	],
	"./Kpica.png": [
		"67d6",
		"chunk-2d0d07c9"
	],
	"./Ktrebol.png": [
		"89d5",
		"chunk-2d0df808"
	],
	"./Qcorazon.png": [
		"8010",
		"chunk-2d0dd00d"
	],
	"./Qdiamante.png": [
		"b1dd",
		"chunk-2d20f1c5"
	],
	"./Qpica.png": [
		"7078",
		"chunk-2d0d5c70"
	],
	"./Qtrebol.png": [
		"2abf",
		"chunk-2d0bd3e9"
	],
	"./grey_back.png": [
		"44a5",
		"chunk-2d0c136a"
	],
	"./red_back.png": [
		"e4dc",
		"chunk-2d225a24"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "dda4";
module.exports = webpackAsyncContext;